<div class="scrollable-container" cdkScrollable>
	<div class="container-padding">
		<div class="container-title title-separation" translate>datacenter.click-on-items-on-the-right</div>
		<ng-container *ngFor="let currentFilter of addedFilters">
			<copo-free-text-filter
					class="values-container"
					#addedFilterHost
					[attr.data-filter-id]="currentFilter.filterId"
					*ngIf="currentFilter.filterType === 'FreeText'"
					[isDefaultFilter]="false"
					[filter]="currentFilter"
					(removeFilter)="removeFilter(currentFilter)"></copo-free-text-filter>
			<copo-global-search-filter
					class="values-container"
					#addedFilterHost
					[attr.data-filter-id]="currentFilter.filterId"
					*ngIf="currentFilter.filterType === 'GlobalSearch'"
					[filter]="currentFilter"
					[isDefaultFilter]="false"
					(removeFilter)="removeFilter(currentFilter)"></copo-global-search-filter>
			<copo-date-filter
					class="values-container"
					#addedFilterHost
					[attr.data-filter-id]="currentFilter.filterId"
					*ngIf="currentFilter.filterType === 'Date'"
					[filter]="currentFilter"
					[isDefaultFilter]="false"
					(removeFilter)="removeFilter(currentFilter)"></copo-date-filter>
			<copo-document-date-filter
					class="values-container"
					#addedFilterHost
					[attr.data-filter-id]="currentFilter.filterId"
					*ngIf="currentFilter.filterType === 'DocumentDate'"
					[filter]="currentFilter"
					(removeFilter)="removeFilter(currentFilter)"></copo-document-date-filter>
			<copo-numeric-filter
					class="values-container"
					#addedFilterHost
					[attr.data-filter-id]="currentFilter.filterId"
					*ngIf="currentFilter.filterType === 'Numeric'"
					[filter]="currentFilter"
					[isDefaultFilter]="false"
					(removeFilter)="removeFilter(currentFilter)"></copo-numeric-filter>
			<copo-suggestive-list-filter
					class="values-container"
					#addedFilterHost
					[attr.data-filter-id]="currentFilter.filterId"
					*ngIf="currentFilter.filterType === 'SuggestiveList'"
					[isDefaultFilter]="false"
					[filter]="currentFilter"
					(removeFilter)="removeFilter(currentFilter)"></copo-suggestive-list-filter>
			<copo-suggestive-list-id-filter
					class="values-container"
					#addedFilterHost
					[attr.data-filter-id]="currentFilter.filterId"
					*ngIf="currentFilter.filterType === 'SuggestiveListWithId'"
					[filter]="currentFilter"
					[isDefaultFilter]="false"
					(removeFilter)="removeFilter(currentFilter)"></copo-suggestive-list-id-filter>
			<copo-shipment-order-number-filter
					class="values-container"
					#addedFilterHost
					[attr.data-filter-id]="currentFilter.filterId"
					*ngIf="currentFilter.filterType === 'ShipmentOrderNumber'"
					[filter]="currentFilter"
					(removeFilter)="removeFilter(currentFilter)"></copo-shipment-order-number-filter>
			<copo-order-number-filter
					class="values-container"
					#addedFilterHost
					[attr.data-filter-id]="currentFilter.filterId"
					*ngIf="currentFilter.filterType === 'OrderNumber'"
					[filter]="currentFilter"
					[isDefaultFilter]="false"
					(removeFilter)="removeFilter(currentFilter)"></copo-order-number-filter>
			<copo-document-order-number-filter
					class="values-container"
					#addedFilterHost
					[attr.data-filter-id]="currentFilter.filterId"
					*ngIf="currentFilter.filterType === 'DocumentOrderNumber'"
					[filter]="currentFilter"
					(removeFilter)="removeFilter(currentFilter)"></copo-document-order-number-filter>
			<copo-boolean-filter
					class="values-container"
					#addedFilterHost
					[attr.data-filter-id]="currentFilter.filterId"
					*ngIf="currentFilter.filterType === 'Boolean'"
					[filter]="currentFilter"
					[isDefaultFilter]="false"
					(removeFilter)="removeFilter(currentFilter)"></copo-boolean-filter>
			<copo-dropdown-filter
					class="values-container"
					#addedFilterHost
					[attr.data-filter-id]="currentFilter.filterId"
					*ngIf="currentFilter.filterType === 'Dropdown'"
					[filter]="currentFilter"
					[isDefaultFilter]="false"
					(removeFilter)="removeFilter(currentFilter)"></copo-dropdown-filter>
			<copo-document-mill-dropdown-filter
					class="values-container"
					#addedFilterHost
					[attr.data-filter-id]="currentFilter.filterId"
					*ngIf="currentFilter.filterType === 'DocumentMillDropdown'"
					[filter]="currentFilter"
					(removeFilter)="removeFilter(currentFilter)"></copo-document-mill-dropdown-filter>
			<copo-document-last-connection-date-filter
					class="values-container"
					#addedFilterHost
					[attr.data-filter-id]="currentFilter.filterId"
					*ngIf="currentFilter.filterType === 'DocumentLastConnectionDate'"
					[filter]="currentFilter"
					(removeFilter)="removeFilter(currentFilter)"></copo-document-last-connection-date-filter>
			<copo-doc-suggestive-list-id-filter
					class="values-container"
					#addedFilterHost
					[attr.data-filter-id]="currentFilter.filterId"
					*ngIf="currentFilter.filterType === 'DocumentSuggestiveListWithId'"
					[filter]="currentFilter"
					[isDefaultFilter]="false"
					(removeFilter)="removeFilter(currentFilter)"></copo-doc-suggestive-list-id-filter>
		</ng-container>
		<div *ngIf="defaultFilters">
			<ng-container *ngFor="let defaultFilter of defaultFilters">
				<copo-suggestive-list-filter class="values-container" *ngIf="defaultFilter.filterType === 'SuggestiveList'" [isDefaultFilter]="true" [filter]="defaultFilter"></copo-suggestive-list-filter>
				<copo-suggestive-list-id-filter class="values-container" *ngIf="defaultFilter.filterType === 'SuggestiveListWithId'" [filter]="defaultFilter" [isDefaultFilter]="true"></copo-suggestive-list-id-filter>
				<copo-order-number-filter class="values-container" *ngIf="defaultFilter.filterType === 'OrderNumber'" [isDefaultFilter]="true" [filter]="defaultFilter"></copo-order-number-filter>
				<copo-free-text-filter class="values-container" *ngIf="defaultFilter.filterType === 'FreeText'" [isDefaultFilter]="true" [filter]="defaultFilter" ></copo-free-text-filter>
				<copo-date-filter class="values-container" *ngIf="defaultFilter.filterType === 'Date'" [isDefaultFilter]="true" [filter]="defaultFilter" ></copo-date-filter>
				<copo-boolean-filter class="values-container" *ngIf="defaultFilter.filterType === 'Boolean'" [isDefaultFilter]="true" [filter]="defaultFilter"></copo-boolean-filter>
				<copo-dropdown-filter class="values-container" *ngIf="defaultFilter.filterType === 'Dropdown'" [isDefaultFilter]="true" [filter]="defaultFilter"></copo-dropdown-filter>
				<copo-numeric-filter class="values-container" *ngIf="defaultFilter.filterType === 'Numeric'" [filter]="defaultFilter" [isDefaultFilter]="true"></copo-numeric-filter>
				<copo-shipment-order-number-filter class="values-container" *ngIf="defaultFilter.filterType === 'ShipmentOrderNumber'" [filter]="defaultFilter" [isDefaultFilter]="true"></copo-shipment-order-number-filter>
				<copo-document-order-number-filter class="values-container" *ngIf="defaultFilter.filterType === 'DocumentOrderNumber'" [filter]="defaultFilter" [isDefaultFilter]="true"></copo-document-order-number-filter>
				<copo-doc-suggestive-list-id-filter class="values-container" *ngIf="defaultFilter.filterType === 'DocumentSuggestiveListWithId'" [filter]="defaultFilter" [isDefaultFilter]="true"></copo-doc-suggestive-list-id-filter>
			</ng-container>
		</div>
	</div>
</div>

<div class="scrollable-container" cdkScrollable>
	<div class="add-filter-sticky-container">
		<div class="add-filter-container">
			<mat-icon color="accent" svgIcon="add"></mat-icon>
			<span class="container-title" translate>datacenter.view.add-filters</span>
		</div>
		<mat-form-field class="column-search" appearance="outline" subscriptSizing="dynamic">
			<mat-icon svgIcon="search" class="column-search-icon column-search-icon-align" matPrefix></mat-icon>
			<input
					[placeholder]="'search.placeholder' | translate"
					matInput
					type="text"
					spellcheck="false"
					autocomplete="off"
					[formControl]="searchTextControl"/>
			<button type="button" *ngIf="searchTextControl.value" matSuffix mat-icon-button
					(click)="searchTextControl.reset('');" tabindex="-1">
				<mat-icon svgIcon="md:close"></mat-icon>
			</button>
		</mat-form-field>
	</div>

	<div class="container-padding">
		<button type="button" mat-stroked-button class="displayed-filter-container" *ngFor="let filter of filtersToShow" (click)="addValueFilter(filter)">
			<mat-icon color="accent" class="margin-icon" svgIcon="add"></mat-icon>
			<span>{{ filter.label }}</span>
		</button>
	</div>
</div>
